export default __webpack_public_path__ + "static/media/Facebook.555148db.webp";